// extracted by mini-css-extract-plugin
export default {"container":"PmsPopup_container__CPNRQ","imgContainer":"PmsPopup_imgContainer__1l3in","card":"PmsPopup_card__Rkgq+","primaryButton":"PmsPopup_primaryButton__hobJN"};